import http from "@/services/http";

export async function fetch(invoiceRequest: any) {
  const { data } = await http().post(
    globalThis.env.API_COMMERCE + "/download-invoice",
    invoiceRequest
  );
  return data;
}
